import {styled} from '@mui/material/styles';

export const CenteredWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  height: '100%',
  alignItems: 'center',
  flex: 1,
});
